const isRecord = (value: unknown): value is Record<string, unknown> =>
  typeof value === 'object' && value !== null && !Array.isArray(value);

export const normaliseResampling = <T extends Record<string, unknown>>(settings: T): T => {
  const vendorSettings = settings.vendorsettings;

  if (!isRecord(vendorSettings)) {
    return settings;
  }

  const resampling = vendorSettings.resampling;

  if (!isRecord(resampling) || resampling.do_resampling !== false) {
    return settings;
  }

  return {
    ...settings,
    vendorsettings: {
      ...vendorSettings,
      resampling: {},
    },
  } as T;
};
